import ApiClient from '@/libs/http-client'

const EventsService = {
    getEvents(id, config) {
        return ApiClient.get(`/api/calendar/events?type=hr_meeting&class=special&id=${id}`, config)
    },
    getCalendarDetails(id, config) {
        return ApiClient.get(`/api/vacations/general?user_id=${id}`, config)
    },
    getVacationsCount(id, config) {
        return ApiClient.get(`/api/vacations/days?user_id=${id}`, config)
    },
    getReports(param, config) {
        return ApiClient.get(`/api/calendar/events?type=hr_meeting&client_id=${param}&class=important`, config)
    },
    updateBirthday(user_id, data, config) {
        return ApiClient.put(`/api/users/birthdays/${user_id}`, data, config)
    },
    updateVacation(event_id, data, config) {
        return ApiClient.put(`/api/vacations/${event_id}`, data, config)
    },
    updateTag(id, data, config) {
        return ApiClient.put(`/api/candidates/tags/${id}`, data, config)
    },
    updateDayOff(event_id, data, config) {
        return ApiClient.put(`/api/days-off/${event_id}`, data, config)
    },
    updateSickday(event_id, data, config) {
        return ApiClient.put(`/api/sick-days/${event_id}`, data, config)
    },
    editMeeting(event_id, data, config) {
        return ApiClient.put(`/api/calendar/events/${event_id}`, data, config)
    },
    deleteMeeting(event_id, config) {
        return ApiClient.delete(`/api/calendar/events/${event_id}`, config)
    },
    deleteVacation(event_id, config) {
        return ApiClient.delete(`/api/vacations/${event_id}`, config)
    },
    deleteDayOff(event_id, config) {
        return ApiClient.delete(`/api/days-off/${event_id}`, config)
    },
    deleteHoliday(event_id, config) {
      return ApiClient.delete(`/api/holidays/${event_id}`, config)
  },
    createOneToOneMeeting(data, config) {
        return ApiClient.post('/api/calendar/events', data, config)
    },
    getDayOffs(config) {
        return ApiClient.get('/api/days-off', config)
    },
    getHolidays(config) {
      return ApiClient.get('/api/holidays', config)
  },
    getSickleave(config, id) {
        return id ? ApiClient.get('/api/sick-days', config) : ApiClient.get('/api/sick-days', config)
    },
    getUserDaysOff(id, config) {
        return ApiClient.get(`/api/days-off?user_id=${id}`, config)
    },
    getVacations(config) {
        return ApiClient.get('/api/vacations', config)
    },
    getUserVacations(id, config) {
        return ApiClient.get(`/api/vacations?user_id=${id}`, config)
    },
    createReport(data, config) {
        return ApiClient.post('/api/calendar/events', data, config)
    },
    createVacation(data, config) {
        return ApiClient.post('/api/vacations', data, config)
    },
    createDayOff(data, config) {
        return ApiClient.post('/api/days-off', data, config)
    },
    createHoliday(data, config) {
      return ApiClient.post('/api/holidays', data, config)
    },
    createSickLeave(data, config) {
        return ApiClient.post('/api/sick-days', data, config)
    }
}

export default EventsService
